import { createFileRoute } from "@tanstack/react-router";
import TestimonialsPage from "@/pages/TestimonialsPage";
export const Route = createFileRoute("/testimonials")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Patient Testimonials & Stories | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Read real patient stories from Neuro Wellness TMS Centers of America in Coral Springs, FL. SAINT® TMS, SPRAVATO®, and TMS therapy patients share their.",
        },
        {
          property: "og:title",
          content:
            "Patient Testimonials & Stories | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Read real patient stories from Neuro Wellness TMS Centers of America in Coral Springs, FL. SAINT® TMS, SPRAVATO®, and TMS therapy patients share their.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/testimonials",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/testimonials",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TestimonialsPage />;
}
